import { render, staticRenderFns } from "./coachEducation.vue?vue&type=template&id=412085a6&scoped=true&"
import script from "./coachEducation.vue?vue&type=script&lang=js&"
export * from "./coachEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412085a6",
  null
  
)

export default component.exports